import React, { useState, useCallback, useRef, useEffect, useContext } from 'react';
import MapVisualization from '/src/Components/MapVisualization/MapVisualization';
import './style.css';
import { AreaDataContext } from '../../../../PropertyExplorer';
import { WindowSizeContext } from '/src/App';
// import { QGDStorage } from '/src/services/QGDStorage';
// import { House } from 'lucide-react';

const AboutMarketSignalsSection = ({
    fipsData,
    propertyData,
    disasterDeclarations,
    marketDataKeys,
    housingMarketData,
    disasterDeclarationsState,
    disasterDeclarationsStateAllCounties,
    title
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const { geoData } = useContext(AreaDataContext);
    const { fips, state } = geoData;
    const stateName = state?.state_long || 'State';
    const county_name = propertyData.data.property_details.county
   
    // const marketScores = housingMarketData.refinedMarketData?.marketScores?.individualDatapointScores
        // Iterate through the marketScores and add the label from the marketDataKeys onto the marketScores object, matching datapointId in marketScores to id in marketDataKeys
    // const marketScoresWithLabels = marketScores.map((score) => {
    //     const matchingKey = marketDataKeys.find((key) => key.id === score.datapointId);
    //     return {
    //         ...score,
    //         label: matchingKey ? matchingKey.label : null
    //     };
    // });

    // console.log('marketScoresWithLabels', marketScoresWithLabels);

    const newMarketScoresObject = housingMarketData?.refinedMarketData?.newMarketScores || {};

    // Get the data from the newMarketScoresObject
    const newMarketScoresDeferTo = newMarketScoresObject?.deferTo || null;
    const newMarketScoresFinalScore = newMarketScoresObject?.finalScore || 0;
    const newMarketScoresFinalScoreTextRating = newMarketScoresObject?.finalScoreTextRating || '';
    const newMarketScoresFinalScorePositiveOrNegativeText = newMarketScoresObject?.finalScorePositiveOrNegativeText || '';
    const newMarketScoresHasSomethingToHighlight = newMarketScoresObject?.hasSomethingToHighlight || false;
    const newMarketScoresHighlightBoth = newMarketScoresObject?.highlightBoth || false;
    const newMarketScoresDatapoints = newMarketScoresObject?.allDatapoints || [];

    
    // Handler to determine the score text and css class of a datapoint based on the score and defer to
    const getScoreTextAndClass = (score, deferTo) => {
        
        const stateDisastersThresholds = {
            low: .55,
            moderate: .8,
            high: 1
        }
        
        const countyDisastersThresholds = {
            low: .3,
            moderate: .7,
            high: 1
        }

        const thresholdsToUse = deferTo === 'stateDisasters' ? stateDisastersThresholds : countyDisastersThresholds;
        const geoCSSText = deferTo === 'stateDisasters' ? 'state' : 'county';
        const isScoreNegative = score < 0;

        const scoreAbsoluteValue = Math.abs(score);

        let scoreText = 'Low';
        let scoreClass = 'low';
        
        if (scoreAbsoluteValue < thresholdsToUse.low) {
            scoreText = 'Low';
            scoreClass = 'low';
        } else if (scoreAbsoluteValue < thresholdsToUse.moderate) {
            scoreText = 'Moderate';
            scoreClass = 'medium';
        } else {
            scoreText = 'High';
            scoreClass = 'high';
        }

        const scoreClassWithGeo = `${scoreClass} ${geoCSSText}`;

        return {
            isScoreNegative: isScoreNegative,
            scoreText: scoreText,
            scoreClass: scoreClassWithGeo,
            scoreToUse: scoreAbsoluteValue
        };
    };
    
    // Iterate through the newMarketScores and add the label from the marketDataKeys onto the newMarketScores object, matching datapointId in newMarketScores to id in marketDataKeys
    const newMarketScoresWithLabels = newMarketScoresDatapoints.map((score) => {
        const matchingKey = marketDataKeys.find((key) => key.id === score.id);
        const whichScoresToHighlight = newMarketScoresDeferTo === 'stateDisasters' ? score.stateDisasters : score.countyDisasters || {};

        const datapointScore = whichScoresToHighlight?.totalPointsPercentage || 0;

        const { isScoreNegative, scoreText, scoreClass, scoreToUse } = getScoreTextAndClass(datapointScore, newMarketScoresDeferTo);

        return {
            ...score,
            label: matchingKey ? matchingKey.label : null,
            isScoreNegative: isScoreNegative,
            scoreText: scoreText,
            scoreClass: scoreClass,
            scoreToUse: scoreToUse
        };
    });

    // Sort the newMarketScoresWithLabels array by scoreToUse, descending
    const sortedNewMarketScoresWithLabels = newMarketScoresWithLabels.sort((a, b) => b.scoreToUse - a.scoreToUse);

    
    // Get the disaster declarations where year is 2021 or later
    // This county
    const disasterDeclarationsLast10Years = disasterDeclarations.filter(declaration => declaration.year >= 2015);

    // Get an array of the disasterNumber values from the disasterDeclarationsLast10Years array
    const disasterDeclarationsLast10YearsDisasterNumbers = disasterDeclarationsLast10Years.map(declaration => declaration.disasterNumber);
    
    // Get the state disaster declarations, also post 2015, and with disasterNumber values NOT in the disasterDeclarationsLast10YearsDisasterNumbers array
    const disasterDeclarationsStateLast10Years = disasterDeclarationsState.filter(declaration => declaration.year >= 2015 && !disasterDeclarationsLast10YearsDisasterNumbers.includes(declaration.disasterNumber));
    
    // Get the state disaster declarations, also post 2015, and with disasterNumber values NOT in the disasterDeclarationsLast10YearsDisasterNumbers array
    const disasterDeclarationsStateAllCountiesLast10Years = disasterDeclarationsStateAllCounties.filter(declaration => declaration.year >= 2015 && !disasterDeclarationsLast10YearsDisasterNumbers.includes(declaration.disasterNumber));
    
    console.log('data from newMarketScoresObject', {
        newMarketScoresDeferTo,
        newMarketScoresFinalScore,
        newMarketScoresFinalScoreTextRating,
        newMarketScoresFinalScorePositiveOrNegativeText,
        newMarketScoresHasSomethingToHighlight,
        newMarketScoresHighlightBoth,
        sortedNewMarketScoresWithLabels,
        disasterDeclarationsLast10Years,
        disasterDeclarationsStateLast10Years,
        disasterDeclarationsStateAllCountiesLast10Years
    });


    const [countyData, setCountyData] = useState(fips);
    const [stateData, setStateData] = useState(state);
    const [parentGeoJson, setParentGeoJson] = useState(null);
    const [childGeoJson, setChildGeoJson] = useState(null);

    useEffect(() => {
        if (!countyData?.geometry?.geo_shape || !stateData?.geometry?.st_asgeojson) return;
        setParentGeoJson(stateData.geometry.st_asgeojson);
        setChildGeoJson(countyData.geometry.geo_shape);
    }, [countyData, stateData]);


    // Get the general NRI datapoint for the county
    const nri_risk_rating = countyData?.RISK_RATING;
    const nri_risk_score = countyData?.RISK_SCORE;

    // Get risk_rating for county if the nri_risk_rating is not available
    let countyRiskRating;
    let countyRiskRatingLowercase;
    let countyRiskRatingLevel;

    if (nri_risk_rating) {
        countyRiskRating = nri_risk_rating;
    } else {
        if (nri_risk_score > 99) {
            countyRiskRating = 'Very High';
            countyRiskRatingLowercase = 'very high';
            countyRiskRatingLevel = 'high';
        } else if (nri_risk_score > 95) {
            countyRiskRating = 'High';
            countyRiskRatingLowercase = 'high';
            countyRiskRatingLevel = 'high';
        } else if (nri_risk_score > 80) {
            countyRiskRating = 'Moderate';
            countyRiskRatingLowercase = 'moderate';
            countyRiskRatingLevel = 'moderate';
        } else if (nri_risk_score > 50) {
            countyRiskRating = 'Relatively Low';
            countyRiskRatingLowercase = 'relatively low';
            countyRiskRatingLevel = 'low';
        } else if (nri_risk_score > 10) {
            countyRiskRating = 'Low';
            countyRiskRatingLowercase = 'low';
            countyRiskRatingLevel = 'low';
        } else {
            countyRiskRating = 'Very Low';
            countyRiskRatingLowercase = 'very low';
            countyRiskRatingLevel = 'low';
        }
    }

    const intro_sentence_1 = `As we talked about earlier, ${county_name} has a ${countyRiskRatingLowercase} level of climate risk. `

    let intro_sentence_2;

    if (countyRiskRatingLevel === 'high') {
        intro_sentence_2 = `As a result, we would expect to see at least some signs of the impact of climate playing out in the housing market across...`
    } else if (countyRiskRatingLevel === 'moderate') {
        intro_sentence_2 = `As a result, we may or may not see any indications of climate risk impacting the housing market across...`
    } else {
        intro_sentence_2 = `As a result, we are less likely to see indications of climate risk impacting the housing market across...`
    }

    const fema_disaster_label = `FEMA Declared Climate Disaster${disasterDeclarationsLast10Years.length > 1 ? 's' : ''} Since 2015`

    const femaDeclaredDisastersLabel = "FEMA Climate Disasters Declared Last 10 Years"

    const femaDeclaredDisastersArray = [
        {
            label: county_name,
            count: disasterDeclarationsLast10Years.length
        },
        {
            label: `Other ${stateName} Counties`,
            count: disasterDeclarationsStateAllCountiesLast10Years.length
        },
        {
            label: 'Statewide Disasters',
            count: disasterDeclarationsStateLast10Years.length
        }
        
    ]

    // Variables we want to use for the section intro text are: 
    // - countyRiskRatingLowercase
    // - newMarketScoresDeferTo
    // - newMarketScoresFinalScore
    // - newMarketScoresFinalScoreTextRating
    // - newMarketScoresFinalScorePositiveOrNegativeText
    // - newMarketScoresHasSomethingToHighlight
    // - newMarketScoresHighlightBoth
    // - disasterDeclarationsLast10Years
    // - disasterDeclarationsStateLast10Years
    // - disasterDeclarationsStateAllCountiesLast10Years
    // - county_name
    // - stateName
    
    let sectionIntroTextFinal = '';
    let sectionIntroStarter = '';
    let countryRiskStarterWord = ''
    let countryRiskFiller = `${county_name} having a ${countyRiskRatingLowercase} level of climate risk, `
    let countryRiskEnd = ''
    let stateContextText = ''
    let countyContextText = ''
    if (!newMarketScoresHasSomethingToHighlight) {
        sectionIntroTextFinal = `It looks like there are no clear signs of climate risk impacting the local housing market for this home. That is exactly what you'd want to see! That said, we are continuously monitoring these markets and new signals appear all the time, so this is still worth keeping an eye on.`
    } else {
        
        const positiveNegativeFormattedText = newMarketScoresFinalScorePositiveOrNegativeText === 'Positive' ? 'positively' : 'negatively'

        if (newMarketScoresFinalScoreTextRating === 'High') {
            countryRiskEnd = `we see real signs of climate ${positiveNegativeFormattedText} impacting this housing market.`
        } else if (newMarketScoresFinalScoreTextRating === 'Moderate') {
            countryRiskEnd = `we see some signs of climate ${positiveNegativeFormattedText} impacting this housing market.`
        } else {
            countryRiskEnd = `we see small signs of climate ${positiveNegativeFormattedText} impacting this housing market.`
        }
        
        if (newMarketScoresFinalScorePositiveOrNegativeText === 'Positive') {

            if (countyRiskRatingLowercase !== 'low') {
                countryRiskStarterWord = 'Despite'
            } else {
                countryRiskStarterWord = 'Aligned with'
            }
        } else {
            if (countyRiskRatingLowercase !== 'low') {
                countryRiskStarterWord = 'Aligned with'
            } else {
                countryRiskStarterWord = 'Despite'
            }
        }
        // Do the county starter text
        if (newMarketScoresDeferTo === 'stateDisasters') {
            stateContextText = `However, it looks like those signals are actually being driven by climate trends and events in other parts of the state.`
        } else { 
            countyContextText = `It looks like those signals are being driven by climate trends and events within this county, with events around the state contributing.`
        }

        
        sectionIntroTextFinal = `As we talked about earlier, ${county_name} has a ${countyRiskRatingLowercase} level of climate risk. `
    }

    const sectionIntroTextCombined = `${sectionIntroStarter} ${countryRiskStarterWord} ${countryRiskFiller} ${countryRiskEnd} ${stateContextText} ${countyContextText}`

    console.log('femaDeclaredDisastersArray', femaDeclaredDisastersArray);
    return (
        <div className="ltv-market-signals-section-container">
            <h2 className="ltv-attractiveness-title">{title}</h2>
            <div className={`about-market-signals-section-container ${deviceType}`}>
                <div className="ltv-market-signals-examining-section-container">
                    <div className="climate-in-your-area-map-container">
                        {parentGeoJson && childGeoJson && (
                            <MapVisualization
                                parentGeoJson={parentGeoJson}
                                childGeoJson={childGeoJson}
                                getBoundsFrom='parent'
                            />
                        )}
                        {/* <span className="climate-in-your-area-map-label">{county_name}</span>
                        <div className={`climate-in-your-area-risk-rating-container ${countyRiskRatingLevel}`}>
                            <span className="climate-in-your-area-risk-rating">{countyRiskRating} Climate Risk</span>
                        </div> */}
                    </div>
                    {/* <div className="ltv-market-signals-examining-disaster-divider"></div> */}
                    <span className="ltv-market-signals-examining-disaster-counts-label text-align-center">{femaDeclaredDisastersLabel}</span>
                    <div className="ltv-market-signals-examining-disaster-counts-frame">
                        {femaDeclaredDisastersArray.map((item) => {
                            return (
                                <div className="ltv-market-signals-examining-disaster-count-frame">
                                    <div className="ltv-market-signals-examining-disaster-count-countainer">
                                        <span>{item.count}</span>
                                    </div>
                                    <span className="text-align-center ltv-market-signals-examining-disaster-count-label">{item.label}</span>
                                </div>
                            )
                        })}


                        {/* <div className="ltv-market-signals-examining-disaster-count-countainer">
                            <span>{disasterDeclarationsLast10Years.length}</span>
                        </div>
                        <span className="text-align-center ltv-market-signals-examining-disaster-count-label">{fema_disaster_label}</span> */}
                    </div>
                </div>
                <div className="ltv-market-signals-examining-section-container">
                    <p className="text-align-center">{sectionIntroTextCombined}</p>
                    <div className="ltv-market-signals-examining-section-market-datapoints-grid">
                        {sortedNewMarketScoresWithLabels.map((key) => {

                            // const score = key.percentageOfTotalWeighted

                            // let color;

                            // if (score >= 70) {
                            //     color = 'red';
                            // } else if (score >= 35) {
                            //     color = 'yellow';
                            // } else {
                            //     color = 'green';
                            // }
                            return (
                                <div className="ltv-market-signals-examining-section-market-datapoint-container">
                                    <div className={`ltv-market-signals-examining-section-market-datapoint-color-indicator ${key.scoreClass}`}></div>
                                    <span className='text-align-center'>{key.label}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutMarketSignalsSection;